export default async function GetSearchLandOwner(text) {
    let url = window.RealestateService+  `/api/Land/SearchLandOwner?searchText=${text}`
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}